<template>
  <CardFrame :bgColor="data.backgroundColor" hasDropShadow>
    <CardContainer class="pt-[50px] md:pt-[55px] xl:pt-[60px]">
      <CardInset>
        <CardStep>{{ stepNumber }}</CardStep>
        <CardHeaderContainer :layout="'inline'">
          <CardImage :imageSize="'inline'" :image="image" />
          <Title class="'text-left'" :headingTag="'h3'" :style="'h3'">
            {{ data.title }}
          </Title>
        </CardHeaderContainer>
        <Hr isEmbedded />
        <CardBodyContainer>
          <CardBody :textAlignment="'left'" :text="data.body"> </CardBody>
        </CardBodyContainer>
      </CardInset>
    </CardContainer>
  </CardFrame>
</template>

<script>
import CardBody from "../../Atoms/Cards/CardBody.vue";
import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import CardImage from "../../Atoms/Cards/CardImage.vue";
import CardInset from "../../Atoms/Cards/CardInset.vue";
import CardStep from "../../Atoms/Cards/CardStep.vue";
import CardHeaderContainer from "../../Atoms/Cards/CardHeaderContainer.vue";
import Hr from "../../Atoms/Hr.vue";
import Title from "../../Atoms/Heading.vue";

export default {
  components: {
    CardBody,
    CardBodyContainer,
    CardContainer,
    CardFrame,
    CardImage,
    CardInset,
    CardStep,
    CardHeaderContainer,
    Hr,
    Title,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    stepNumber: {
      type: String,
      required: true,
      default: 1,
    },
  },
  setup(props) {
    const image = props.data.hasOwnProperty("image")
      ? props.data.image
      : props.data.icon;

    return {
      image,
    };
  },
};
</script>
